export default __webpack_public_path__ + "static/media/people.18a11ae4.png";